var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"toast-wrapper"},[_c('div',{staticClass:"toast",class:`toast-${_vm.type}`},[_vm._v(" "+_vm._s(_vm.message)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }